import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../firebase/firebaseConfig';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { LOGIN } from '../../../constants/routes';
import { notifyWarning } from '../../../utils/Notify';
import BackButton from '../../../components/button/BackButton';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const onblurScrolltoTop = () => {
    window.scrollTo(0, 0);
    if (document.getElementById('page_account')) {
      document.getElementById('page_account').scrollTop = 0;
    }
  };

  const handleForgottenPassword = async () => {
    const email = document.getElementById('emailforgotPassword').value;
    try {
      await sendPasswordResetEmail(auth, email);
      Swal.fire({
        title: 'Un mail de réinitialisation a été envoyé  !',
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Continuer',
        buttonsStyling: false,
        customClass: {
          confirmButton:
            'bg-[#16c72e] p-4 !rounded-md payer w-full geomanistBold',
        },
      });
      navigate(LOGIN, {
        state: {
          resetEmail: email,
        },
      });
    } catch (e) {
      if (e.message === 'Firebase: Error (auth/user-not-found).') {
        notifyWarning('Erreur', 'Email introuvable', "D'accord");
      } else {
        alert(e);
      }
    }
  };

  return (
    <div>
      <BackButton onClick={() => navigate(LOGIN)} isAbsolute={true} />

      <div className=" createaccount bg-gradient2">
        <h2 className="titre-reset-password">
          Réinitialisation du mot de passe
        </h2>
        <div className="groupinput w-full flex items-center">
          <div className="w-5/6">
            <div className="inputGroup w-full flex flex-col items-start">
              <input
                className="user_mail_input w-full"
                type="email"
                id="emailforgotPassword"
                placeholder="Entre ton email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                onBlur={onblurScrolltoTop}
                onFocus={onblurScrolltoTop}
              />
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button
              type="button"
              disabled={!email.toLowerCase().match(emailRegex)}
              className={`${email.toLowerCase().match(emailRegex) ? '' : 'grayscale'} payer p-6 my-8 text-3xl geomanistBold w-5/6`}
              onClick={() => handleForgottenPassword()}
            >
              Réinitialiser
            </button>
          </div>
          <button
            type="button"
            onClick={() => navigate(LOGIN)}
            className="  text-2xl text-gray-500 hover:text-gray-700 focus:outline-none my-8 w-full"
          >
            Déjà un compte ?{' '}
            <strong className="geomanistBold">Connexion</strong>{' '}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
